module.exports = __webpack_public_path__ + "img/physio_website_access.4cc4f3bb.jpg";